/*
 * @Description:对象管理--系统对象/外部对象/全局字段
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  或: 'or',
  系统: 'system',
  必填: 'required',
  启用: 'enable',
  停用: 'disable',
  状态: 'status',
  参数: 'parameters',
  字段ID: 'Field ID',
  类型: 'type',
  非必填: 'not required',
  选项值: 'option value',
  新建对象: 'create object',
  系统对象: 'System object',
  对象名称: 'Object name',
  对象类型: 'Object type',
  自动获取字段: 'Auto sync field',
  '自动获取飞书审批字段，可能会对您现有配置产生更新，是否确认': 'Auto sync field, may cause update to your existing configuration, do you confirm?',
  新建字段: 'Create field',
  字段名称: 'field name',
  字段设置: 'field settings',
  字段标识: 'field identifier',
  字段类型: 'field type',
  是否必填: 'is required',
  视图: 'view',
  创建视图: 'create view',
  系统视图: 'system view',
  公共视图: 'public view',
  全部成员: 'all members',
  视图名称: 'view name',
  视图类型: 'view type',
  适用范围: 'scope of application',
  编辑视图: 'edit view',
  数据条件: 'data conditions',
  外部对象: 'external objects',
  添加字段: 'add field',
  新增字段: 'new field',
  编辑字段: 'edit field',
  设置选项: 'set options',
  添加选项: 'add options',
  批量添加: 'batch add',
  '每行可输入一个选项，回车键可换行': 'Each line can enter one option, press Enter to enter a new line',
  '可输入选项名称和apiname，可用英文冒号隔开。例如【男:man】': 'Input option name and apiname, separated by English colon. For example, 【man:man】',
  单选按钮: 'radio button',
  多选按钮: 'checkbox',
  下拉单选: 'drop-down single selection',
  下拉多选: 'drop-down multiple selection',
  级联选择: 'cascade selection',
  审批定义code: 'approval definition code',
  自定义字段: 'custom field',
  新增或关系: 'new or association',
  新增审批模板: 'add external objects',
  编辑审批模板: 'edit external objects',
  状态更新失败: 'status update failed',
  监听的字段编码: 'listening field encoding',
  修改字段状态失败: 'field status modification failed',
  系统字段不允许修改: 'system field not allowed to modify',
  监听的合同类型缩写: 'listening contract type abbreviation',
  字段详情获取失败: 'field details acquisition failed',
  新增全局字段信息失败: 'addition of global field information failed',
  获取全局字段列表失败: 'failure to obtain global field list',
  编辑全局字段信息失败: 'global field information editing failed',
  字段名称信息校验失败: 'field name information validation failed',
  数据条件筛选不符合规则: 'data condition filtering does not comply with the rules',
  数据对象: 'Data Object',
  请输入姓名: 'Please enter the name',
  请选择部门: 'Please select a department',
  部门人数: 'Department size',
  部门负责人: 'Department leader',
  组织用户: 'Organizational users',
  离职人员列表: 'Departed employees list',
  转移数据: 'Transfer data',
  离职日期: 'Date of departure',
  接收人员: 'Receiver',
  新增规则: 'Add rule',
  角色名: 'Role name',
  角色名不能为空: 'Role name cannot be empty',
  '请输入姓名/部门': 'Please enter a name/department',
  角色名不能超过300个字: 'Role name cannot exceed 300 characters',
  请选择一个人员: 'Please select an individual',
  请选择接收人员: 'Please select a receiver',
  查重已关闭: 'Duplicate check is off',
  请开启查重: 'Please turn on duplicate check',
  联合查重客户: 'Duplicates checking with customers',
  搜索字段名称: 'Search field name',
  搜索视图名称: 'Search view name',
  是否开启查重: 'Duplicate check activated?',
  请输入视图名称: 'Please enter view name',
  视图名称为必选项: 'View name is required',
  视图类型为必选项: 'View type is required',
  '查重条件不能为空，请重新设置': 'Duplicate check condition cannot be empty, please reset',
  复制视图: 'Copy View',
  自定义选项: 'Custom Option',
  使用全局字段: 'Use Global Field',
  请设置选项名称: 'Please Set Option Name',
  请设置选项值: 'Please Set Option Value',
  示例: 'Example',
  不限: 'Unlimited',
  编码: 'Encoding',
  前编码: 'Front Encoding',
  后编码: 'Back Encoding',
  不启用: 'Disable',
  数据格式: 'Data Format',
  日期格式: 'Date Format',
  范围格式: 'Range Format',
  字段示例: 'Field Example',
  关联对象: 'Related Object',
  编码预览: 'Encoding Preview',
  插入年份: 'Insert Year',
  插入月份: 'Insert Month',
  插入日期: 'Insert Date',
  流水位数: 'Serial Number',
  今日及以前: 'Today and Before',
  今日及以后: 'Today and After',
  请输入前编码: 'Please Enter Front Encoding',
  请输入后编码: 'Please Enter Back Encoding',
  支持文件类型: 'Supported File Type',
  最大文件数量: 'Maximum File Count',
  支持输入大小写字母组合: 'Support input of uppercase and lowercase letter combinations',
  支持输入字母数字下划线组合: 'Supports inputting combinations of letters, numbers, and underscores',
  支持输入字母数字组合: 'Supports inputting combinations of letters and numbers',
  支持输入字母下划线组合: 'Support input of letter and underline combinations',
  请按规则输入字段标识: 'Please enter field identifiers according to the rules',
  请选择数据格式: 'Please Select Data Format',
  请输入计算公式内容: 'Please enter the content of the calculation formula',
  请选择日期格式: 'Please Select Date Format',
  选项值为必填项: 'Option Value is Required',
  关联对象为必选项: 'Related Object is Required',
  请选择全局字段类型: 'Please Select Global Field Type',
  单个文件不得超过300M: 'Single File Cannot Exceed 300M',
  请选择支持的文件类型: 'Please Select Supported File Type',
  '最大文件数量不能为空,请重新设置': 'Maximum File Count cannot be empty, please set it again.',
  '支持文件类型不能为空,请重新设置': 'Supported File Type cannot be empty, please set it again.',
  请输入对象名称: 'Please enter object name',
  请选择对象类型: 'Please select object type',
  '请输入id/code值': 'Please enter id/code value',
  请输入监听的字段编码: 'Please enter field code to listen',
  请输入合同类型: 'Please enter contract type',
  任务描述: 'Task Description',
  完成条件: 'Completion Conditions',
  条件类型: 'Condition Type',
  空任务: 'Empty Task',
  请选择对象: 'Please Select an Object',
  请输入任务描述: 'Please Enter Task Description',
  '云文档/附件类型': 'Cloud Document/Attachment Type',
  '请选择云文档/附件类型': 'Please Select Cloud Document/Attachment Type',
  '多用于线下辅助的任务，起提醒作用': 'Mostly used for offline assistive tasks, to serve as a reminder',
  请输入接口参数: 'Please enter the interface parameter',
  请设置选项key值: 'Please set the option key value',
  请设置选项value值: 'Please set the option value',
  请选择映射类型: 'Please select the mapping type',
  请选择来源对象: 'Please select the source object',
  请选择字段: 'Please select the field',
  请选择映射至对象: 'Please select the object to map to',
  请选择映射对象和源对象对应的字段值: 'Please select the field value corresponding to the mapping object and the source object',
  自定义视图: 'Customize the view',
  外部页面视图: 'External page view',
  视图设置: 'View settings',
  查重设置: 'Check duplicate settings',
  布局设置: 'Layout settings',
  按钮设置: 'Button settings',
  显示停用字段: 'Displays the deactivate field',
  分配布局: 'Allocation Layout',
  列表页布局: 'List Page Layout',
  详情页布局: 'Detail Page Layout',
  新建页布局: 'Create Page Layout',
  编辑页布局: 'Edit Page Layout',
  引用自: 'Quoted from',
  引用自为必选项: 'Reference is mandatory',
  请选择引用自: 'Please select Quote from',
  引用字段: 'Reference field',
  引用字段为必选项: 'The reference field is mandatory',
  请选引用字段: 'Please select the reference field',
  可选数量: 'Optional Quantity',
  可选一个部门: 'Select One Department',
  可选多个部门: 'Select Multiple Departments',
  请输入单位: 'Please input the unit',
  省略末尾的0: 'Omit the 0 at the end',
  '单位仅用于展示，不参与计算；': 'The unit is for display only and does not participate in calculation;',
  '数据格式选择百分比时，单位值不可修改': 'When the data format is selected as percentage, the unit value cannot be modified',
  '勾选后，当不足小数位数时省略末尾的0。如设置保留3位小数时，默认显示完整小数位数为1.600，勾选后则显示为1.6': 'After selecting, omit the 0 at the end when it is less than the decimal place. If set to retain 3 decimal places, the default displayed full decimal place is 1.600. If checked, it will display 1.6 decimal places',
  选择计算类型: 'Select the type of calculation',
  计算公式: 'Calculation formula',
  请选择主对象: 'Please select the main object',
  请选择关联对象: 'Please select the associated object',
  请选择对象下字段: 'Please select the field under the object',
  请选择汇总类型: 'Please select a summary type',
  汇总类型: 'Summary type',
  '计算关联对象的数据条目数，如：客户下的订单数量': 'Calculate the number of data entries of associated objects, such as the number of orders placed by a customer',
  '计算某数字型字段的求和值，如：订单下产品数量合计': 'Calculate the sum value of a numerical field, such as the total quantity of products under an order',
  汇总字段: 'Summary field',
  请选择汇总字段: 'Please select a summary field',
  请选择数据范围: 'Please select data range',
  数据范围: 'Data range',
  满足关联关系的所有数据: 'All data that satisfies the association relationship',
  自定义数据范围: 'Custom data range',
  请输入计算公式: 'Please enter the calculation formula',
  插入字段: 'Insert field',
  搜索插入字段: 'Search Insert Field',
  插入运算符: 'insertion operator',
  插入函数: 'Insert Function',
  其他设置: 'Other settings',
  语法检查: 'Grammar check',
  请选择空白字段设置: 'Please select a blank field setting',
  空白字段设置: 'Blank field settings',
  主对象: 'Main object',
  计算类型: 'Calculation type',
  百分比: 'Percentage',
  数字: 'Number',
  金额: 'Amount',
  文本: 'Text',
  空白字段默认为1: 'The blank field defaults to 1',
  空白字段默认为0: 'The blank field defaults to 0',
  '数字（汇总累计）': 'Number(Summarize and accumulate)',
  '金额（汇总累计）': 'Amount(Summarize and accumulate)',
  '计算结果等于数字，示例：总数量 = 购买数量 + 赠送数量': 'The calculation result is equal to a number, example: total quantity = purchase quantity + gift quantity',
  '计算结果自动加百分比，示例：折扣 = 折后价 / 原价': 'The calculation result automatically adds a percentage, example: discount = discounted price / original price',
  '计算结果等于金额，示例：总金额 = 单价 * 数量': 'The calculation result is equal to the amount, example: total amount = unit price * quantity',
  '计算结果等于文本，一般用于串联其他字段，示例：商机名称 = CONCATENATE(客户名称 ， 创建日期)': 'The calculation result is equal to the text and is generally used to concatenate other fields. For example, opportunity name=CONCATENATE(customer name，creation date)',
  '计算结果等于数字，一般用于汇总关联对象的数量，示例：统计客户下订单数量': 'The calculation result is equal to a number and is generally used to summarize the number of associated objects. Example: counting the number of orders placed by customers.',
  '计算结果等于金额，一般用于汇总关联对象的金额，示例：统计客户下所有订单总金额': 'The calculation result is equal to the amount, which is generally used to summarize the number of associated objects. Example: counting the total amount of all orders placed by the customer.',
  对象标识: 'Object flag',
  对象图标: 'Object icon',
  请选择对象图标: 'Please select the object icon',
  主属性字段: 'Main attribute field',
  按钮名称: 'Button name',
  按钮类型: 'Button type',
  按钮标识: 'Button flag',
  按钮位置: 'Button position',
  按钮图标: 'Button icon',
  展示方式: 'showType',
  说明: 'Description',
  '图标+文字展示': 'Icon + Text show',
  文字展示: 'Text show',
  图标展示: 'Icon show',
  '列表布局-通用操作': 'ListLayout-General operation',
  '列表布局-批量操作': 'ListLayout-Batch operation',
  '列表布局-快捷操作': 'ListLayout-Quick operation',
  布局名称: 'Layout Name',
  是否展示: 'Display',
  新建布局: 'New layout',
  编辑布局: 'Edit layout',
  详情布局: 'Layout detail',
  通用按钮: 'Universal button',
  可选按钮: 'Optional button',
  已选按钮: 'Selected button',
  批量操作按钮: 'Batch operation button',
  快捷操作按钮: 'Quick Action Button',
  显示1个: 'Show one',
  显示2个: 'Show two',
  显示3个: 'Show three',
  显示4个: 'Show four',
  请输入说明信息: 'Please enter the description information',
  '停用后该对象无法再新增数据，是否确认？': 'After disabling, the object cannot add data, is it sure?',
  导入设置: 'Import settings',
  搜索对象名称: 'Search object name',
  请输入字段标识: 'Please enter the field flag',
  '自定义对象下已存有数据，不能直接删除对象': 'Custom objects have data stored, cannot be deleted directly',
  '删除后该自定义对象将不再可见，是否确认？': 'Custom objects are no longer visible after deletion, is it sure?',
  主属性字段设置: 'Primary attribute field settings',
  数据权限设置: 'Data permission settings',
  私有: 'Private',
  全员公开: 'Public',
  '登录人数据权限不同，看到的数据范围不同，上级部门的部门负责人可以看到下级部门的所有数据。': 'The number of logins is different, the data range seen is different. The department principal of the upper-level department can see all the data of the lower-level department.',
  '数据可以设置协作人，且可以对协作人指定是读写、只读权限': 'Data can be set to collaborators, and can specify read/write and read-only permissions for collaborators',
  '数据在全租户内共享，与登录人的数据权限无关': 'Data is shared across all tenants, and has no relationship with the data permission of the login person',
  租户内每个人都能看到这个对象下的所有数据: 'Everyone in the tenant can see all the data under this object',
  '该对象的主属性字段，可理解为该条数据的“标题”': 'The primary attribute field of the object, which can be understood as the "title" of the data',
  只能将一个单行文本或编码字段作为主属性字段: 'Can only be a single line of text or a code field as the primary attribute field',
  数据权限范围内: 'Data permission range',
  符合条件的数据: 'Data that meets the conditions',
  下拉显示字段: 'Drop-down display field',
  请选择下拉显示字段: 'Please select the drop-down display field',
  弹窗显示字段: 'Pop-up display field',
  设置数据条件: 'Set data conditions',
  请完善数据条件: 'Please complete the data conditions',
  属于当前操作人: 'Belongs to the current operator',
  当前时间: 'Current time',
  属于当前操作人部门: 'Belongs to the current operator department',
  最多可选5个字段: 'Up to 5 fields can be selected',
  审批组织: 'Approval organization',
  请输入审批组织: 'Please enter the approval organization',
  子字段设置: 'Subfield settings',
  子表单数量超出限额: 'The number of subforms exceeds the quota',
  '请确定最新的字段属性！': 'Please determine the latest field properties!',
  '此计算公式配置有误，请重新设置': 'This calculation formula is incorrectly configured. Please reset it',
  '此项配置有误，请检查字段属性': 'This configuration is incorrect, please check the field properties',
  '该字段删除后无法被恢复，请确认是否要删除？': 'This field cannot be restored after deletion. Please confirm if you want to delete it?',
  从左侧拖拽添加字段: 'Drag and drop to add fields from the left'
};
